import { render } from "./ProjectPage.vue?vue&type=template&id=c207d952&scoped=true"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"

import "./ProjectPage.vue?vue&type=style&index=0&id=c207d952&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c207d952"

export default script